import { api } from './api';
import { validateProfilePicture } from '../utils/profilePicture';

const requireOrganizationAccess = (actor) => {
    if (!actor?.user?.uuid || !['ACCOUNT_ADMIN', 'CLINIC_ADMIN'].includes(actor.role?.name)
        || actor.role.disabled || !actor.role.uuid || !actor.role.account?.uuid) throw new Error('ORGANIZATION_ACCESS_DENIED');
    return { 'CHEART-ROLE': actor.role.uuid };
};

export const updateOrganizationAddress = async (actor, patch) => {
    const headers = requireOrganizationAccess(actor);
    const payload = {};
    for (const key of ['street', 'zip', 'city', 'province', 'country']) {
        if (!Object.prototype.hasOwnProperty.call(patch, key)) continue;
        if (typeof patch[key] !== 'string') throw new Error('INVALID_ORGANIZATION_ADDRESS');
        const value = patch[key].trim();
        if (key === 'country' && !value) throw new Error('COUNTRY_CANNOT_BE_CLEARED');
        payload[key] = value;
    }
    if (!Object.keys(payload).length) return payload;
    await api.patch('/cheart/clinic/address', payload, { headers });
    return payload;
};

export const uploadOrganizationPicture = async (actor, file) => {
    const headers = requireOrganizationAccess(actor);
    const validationError = validateProfilePicture(file);
    if (validationError) throw new Error(validationError);
    const body = new FormData();
    body.append('picture', file);
    const { data } = await api.post('/cheart/clinic/picture', body, {
        headers: { ...headers, 'Content-Type': null }
    });
    if (typeof data?.picture !== 'string' || !data.picture) throw new Error('PICTURE_UNAVAILABLE');
    return data.picture;
};
